/**
 * create address as a string from the address object
 * @param address
 * @returns {string}
 */
export default function formatAddress(address) {
  const addressPart1 = (isEmptyOrNull(address.address1) ? '' : (address.address1 + ' '))
    + (isEmptyOrNull(address.address2) ? '' : (address.address2 + ' '))
    + address.address3;
  const addressPart2 = (isEmptyOrNull(address.city) ? '' : (address.city + ' '))
    + (isEmptyOrNull(address.stateCode) ? '' : (address.stateCode + ' '))
    + address.postalCode;
  let addressString = '';
  if (!isEmptyOrNull(addressPart1)) {
    addressString = addressPart1.trim();
  }
  // add comma and part 2 if there is something in address and part2 also exists, else simply assign part2
  if (!isEmptyOrNull(addressPart2) && !isEmptyOrNull(addressString)) {
    addressString = addressString + ', ' + addressPart2.trim();
  } else if (isEmptyOrNull(addressString)) {
    addressString = addressPart2.trim();
  }

  // add comma and country if there is something in address and country also exists
  if (!isEmptyOrNull(address.countryCode) && !isEmptyOrNull(addressString)) {
    addressString = addressString + ', ' + address.countryCode;
  } else if (isEmptyOrNull(addressString)) { // if there is nothing in address and we have country
    addressString = address.countryCode;
  }
  // do nothing if there is no country
  return addressString;
}

function isEmptyOrNull(data) {
  return !data || data.trim() === '';
}
